import React from "react";
import "./Equipe.css";

const members = [
  {
    id: "thomas",
    name: "Thomas Kozera",
    role: "Responsable de salle",
    img: "/images/Thomas.jpg",
    bio: [
      "Nous vous présentons Thomas. Depuis toujours passionné par la restauration, il a trouvé sa voie dès ses premières expériences dans le milieu.",
      "Pour parfaire son savoir-faire, il a poursuivi son parcours à l'école hôtelière de Namur, où il a affûté son sens du service et du détail.",
      "Polyvalent, tel un couteau suisse, Thomas sait débarrasser, présenter l'addition et déboucher une bouteille de vin plus vite que son ombre.",
      "Chez Trilogie, Thomas peut donner libre cours à sa passion, car ici, la cuisine se fait à six mains et à trois cœurs, dans une parfaite harmonie entre salle et fourneaux.",
      "Thomas, c'est l'énergie, la précision… et surtout la passion au service de nos clients.",
    ],
  },
  {
    id: "jonathan",
    name: "Jonathan Hernandéz",
    role: "Chef de cuisine",
    img: "/images/Jonathan.jpg",
    bio: [
      "Jonathan, arrivé en Belgique à l'âge de 16 ans, il a laissé derrière lui sa famille au Nicaragua, poussé par un seul désir : devenir cuisinier.",
      "Ce chef haut en couleur ne parlait pas un mot de français à son arrivée, et pourtant, aujourd'hui, il arbore un accent aussi naturel que celui de n'importe quel natif d'ici.",
      "Jonathan s'est formé dans de nombreuses maisons de renom, dont certaines étoilées, et a terminé deuxième au concours des cuisiniers du Benelux.",
      "Sa cuisine est à l'image de ce chef passionné : généreuse, créative, avec un petit « je ne sais quoi » venu d'ailleurs… du Nicaragua, peut-être ?",
    ],
  },
  {
    id: "quentin",
    name: "Quentin Penoit",
    role: "Chef de cuisine",
    img: "/images/Quentin.jpg",
    bio: [
      "On vous présente le dernier membre de l'équipe, Quentin !",
      "Depuis l'enfance, il trouvait déjà son bonheur à regarder sa maman cuisiner, fasciné par ces gestes simples qui donnaient vie aux plats. De cette curiosité est née une passion… et un métier.",
      "Après un diplôme de l'école hôtelière de Namur, il a affiné son savoir-faire dans de prestigieuses maisons étoilées. Durant ce parcours, il s'est laissé séduire par l'élégance de la cuisine française et la générosité de la gastronomie italienne – avec une petite faiblesse pour les ravioles de pâte fraîche",
      "Sa cuisine ? Franche, technique et surtout goûtue ! Son secret ? Ne jamais compter les calories… Car en cuisine comme en amour, quand on aime on ne compte pas.",
    ],
  },
];

function Equipe() {
  return (
    <main className="equipe-page" aria-labelledby="equipe-title">

      {/* ── En-tête ─────────────────────────────────────────── */}
      <header className="equipe-header">
        <span className="equipe-eyebrow">Rencontrez</span>
        <h1 id="equipe-title">
          Notre <em>équipe</em>
        </h1>
        <div className="equipe-header-divider" />
        <p className="lead">
          Découvrez les visages derrière notre cuisine et notre accueil —
          des savoir-faire, des sourires et une passion partagée pour la bonne table.
        </p>
      </header>

      {/* ── Membres ─────────────────────────────────────────── */}
      <section className="equipe-container" aria-live="polite">
        {members.map((m, idx) => (
          <article
            key={m.id}
            className="person-container"
            aria-labelledby={`name-${m.id}`}
          >
            <figure className="person-photo">
              <img
                src={m.img}
                alt={`Portrait de ${m.name}`}
                loading="lazy"
                width="1200"
                height="1600"
              />
            </figure>

            <div
              className="text-wrapper"
              data-index={String(idx + 1).padStart(2, '0')}
            >
              <span className="person-number">
                {String(idx + 1).padStart(2, '0')} / {String(members.length).padStart(2, '0')}
              </span>
              <h2 id={`name-${m.id}`}>{m.name}</h2>
              <div className="role">{m.role}</div>
              <div className="bar" aria-hidden="true" />
              {m.bio.map((paragraph, i) => (
                <p key={i}>{paragraph}</p>
              ))}
            </div>
          </article>
        ))}
      </section>

      {/* ── Photo de groupe ─────────────────────────────────── */}
      <section className="equipe-group" aria-labelledby="equipe-group-title">
        <figure className="equipe-group-photo">
          <img
            src="/images/Equipe-complete.jpeg"
            alt="L'équipe complète du restaurant Trilogie, réunie en terrasse"
            loading="lazy"
          />
        </figure>
        <p id="equipe-group-title" className="equipe-group-caption">
          Toute l'équipe Trilogie, réunie autour d'une <em>même passion</em> :
          vous offrir une expérience chaleureuse et authentique.
        </p>
      </section>

      {/* ── CTA ─────────────────────────────────────────────── */}
      <footer className="equipe-footer">
        <p className="equipe-footer-text">
          Une question ? Un événement privé ? Nous sommes à votre écoute.
        </p>
        <a
          className="contact-btn"
          href="mailto:trilogie.restaurant@gmail.com"
        >
          Nous contacter
          <span className="contact-btn-arrow" />
        </a>
      </footer>

    </main>
  );
}

export default Equipe;
